import * as React from 'react'

import type AccessGroup from 'modules/core/store/models/AccessGroup'

import Table from './Table'

interface Props {
  accessGroup?: AccessGroup | null | undefined
  surveyId: number
}

export default function AccessGroupTable({ accessGroup, surveyId }: Props) {
  if (!accessGroup) return null

  return <Table accessGroup={accessGroup} surveyId={surveyId} />
}
